import React, { useState, useEffect } from "react";
import {
  AreaChart,
  Tooltip,
  Area,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";
import useInterval from "@rooks/use-interval";
// import axios from "axios";
import axios from "../../../api/axios";
import clsx from "clsx";

import EilatGouge from "./EilatGouge";
import EilatPieChart from "./EilatPieChart";
import GroupedStackedBarChart from "./GroupedStackedBarChart";
import LineChart from "./LineChart";
import StackedChart from "./StackedBarChart";

// import InfoBox from "../../InfoBox";
// import GreenArrowUp from "../../../images/GreenArrowUp";
// import RedArrowDown from "../../../images/RedArrowDown";

var request_updateTimelineData_safe = true;
var request_updateGouge_safe = true;
var request_updateTotalWeekAgo_safe = true;

function getLocalHour(date) {
  if (date) {
    let hour = new Date(date).getHours();
    return hour < 10 ? `0${hour}:00` : `${hour}:00`;
  }
}
function checkIfXSecPass(timestamp, x) {
  const currentTime = new Date();
  let plusTenSec = new Date(timestamp).setSeconds(
    new Date(timestamp).getSeconds() + x
  );

  return (currentTime.getTime() - new Date(plusTenSec).getTime()) / 1000 > x;
}
function calcPercent(weekAgo, today) {
  if (today === 0 || weekAgo === 0) {
    return ["N/A", "gray"];
  } else {
    if (today > weekAgo) {
      let percentTotal = ((weekAgo / today - 1) * 100).toFixed(1);
      return [Math.abs(percentTotal), "green"];
    } else {
      let percentTotal = ((today / weekAgo - 1) * 100).toFixed(1);
      return [Math.abs(percentTotal), "red"];
    }
  }
}

function getHourTitleFromPayload(payload) {
  let hour = payload[0]
    ? payload[0].payload["hour"]
    : payload[1]
    ? payload[1].payload["hour"]
    : "";

  return hour + ` - ${hour.split(":")[0] + ":59"}`;
}

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    // let currentDay = payload[0].payload.day.split("/");
    return (
      <div className="bg-white shadow-xl p-1 text-sm border rounded-md space-y-1 animate-fadeIn">
        <p className="font-bold">
          {/* {new Date(currentDay[1] + "/" + currentDay[0] + "/" + new Date().getUTCFullYear()).toDateString()} */}
          {/* {label + ":00 - " + label + ":59"} */}
          {getHourTitleFromPayload(payload)}
        </p>
        {payload[1] && (
          <p
            className={clsx(
              { "text-green-700": payload[1].dataKey === "inCount" },
              { "text-red-500": payload[1].dataKey === "outCount" }
            )}
          >{` ${payload[1].value.toLocaleString()}`}</p>
        )}
        {payload[0] && (
          <p
            className={clsx(
              { "text-blue-700": payload[0].dataKey === "inCount" },
              { "text-indigo-700": payload[0].dataKey === "outCount" }
            )}
          >
            {payload[0].dataKey === "inCount"
              ? `Entering : ${payload[0].value.toLocaleString()}`
              : `Leaving : ${payload[0].value.toLocaleString()}`}
          </p>
        )}
      </div>
    );
  }

  return null;
};
const CustomTooltips = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    // let currentDay = payload[0].payload.day.split("/");
    return (
      <div className="bg-white shadow-xl p-1 text-sm border rounded-md space-y-1 animate-fadeIn">
        <p className="font-bold">
          {/* {new Date(currentDay[1] + "/" + currentDay[0] + "/" + new Date().getUTCFullYear()).toDateString()} */}
          {/* {label + ":00 - " + label + ":59"} */}
          {getHourTitleFromPayload(payload)}
        </p>
        {payload[1] && (
          <p
            className={clsx(
              { "text-green-700": payload[1].dataKey === "inCount" },
              { "text-red-500": payload[1].dataKey === "outCount" }
            )}
          >{` ${payload[1].value.toLocaleString()}`}</p>
        )}
        {payload[0] && (
          <p
            className={clsx(
              { "text-blue-700": payload[0].dataKey === "inCount" },
              { "text-indigo-700": payload[0].dataKey === "outCount" }
            )}
          >
            {payload[0].dataKey === "inCount"
              ? `Entering : ${payload[0].value.toLocaleString()}`
              : `Leaving : ${payload[0].value.toLocaleString()}`}
          </p>
        )}
      </div>
    );
  }

  return null;
};

function findHourData(timeline, hour) {
  for (let i = 0; i < timeline.length; i++) {
    if (timeline[i]["hour"] === hour) {
      return timeline[i];
    }
  }
  return -1;
}

function margeSameHours(timeline) {
  let temp = [];
  for (let i = 0; i < timeline.length; i++) {
    let currentChecker = timeline[i];

    for (let j = i + 1; j < timeline.length; j++) {
      if (
        parseInt(timeline[i]["hour"].split(":")[0]) ===
        parseInt(timeline[j]["hour"].split(":")[0])
      ) {
        currentChecker["inCount"] += timeline[j]["inCount"];
        currentChecker["outCount"] += timeline[j]["outCount"];
        currentChecker["otherCount"] += timeline[j]["otherCount"];
        currentChecker["vehiclesCount"] += timeline[j]["vehiclesCount"];
        currentChecker["total"] += timeline[j]["total"];
      }
    }
    temp.push(currentChecker);
  }
  return temp;
}

function fillLine(timeline) {
  let temp = [];

  // Minus 1 to hide current hour (if now it's 10:40, show in the chart only until 9:59)
  for (let i = 0; i < new Date().getHours(); i++) {
    let hour = i < 10 ? `0${i}:00` : `${i}:00`;
    let res = findHourData(timeline, hour);
    if (res !== -1) {
      temp.push(res);
    } else {
      temp.push({
        hour: hour,
        deviceId: timeline.deviceId,
        inCount: 0,
        outCount: 0,
        vehicles: 0,
      });
    }
  }
  return temp;
}
const EilatGougeAndChartToday = ({ token, areas }) => {
  const [timelineData, setTimelineData] = useState([]);
  const [hotelTimelineData, setHotelTimelineData] = useState([]);
  const [totalCountVehicles, setTotalCountVehicles] = useState(0);
  const [totalWeekAgo, setTotalWeekAgo] = useState(0);
  const [compareText, setCompareText] = useState("N/A");
  const [compareColor, setCompareColor] = useState("gray");
  const [loadingGouge, setLoadingGouge] = useState(true);
  const [loadingChart, setLoadingChart] = useState(true);
  const [deviceVelocity, setdeviceVelocity] = useState([]);
  const [deviceKeys, setDeviceKeys] = useState([]);
  const [devicesNames, setdevicesNames] = useState([]);
  const [pie, setPie] = useState(new Map());
  const [types, setTypes] = useState([]);
  const colors = ["#809AE6", "#0A3580", "#6D2FD7", "#C1B4DD", "#A398B9"];
  function getDeviceNames() {
    let map = new Map();
    Array.from(areas).forEach((area) => {
      Array.from(area.devices).forEach((device) => {
        map.set(device.deviceId, device.name);
      });
    });
    setdevicesNames((prev) => map);
  }

  function updateGougeData() {
    if (request_updateGouge_safe === false) {
      return;
    } else {
      request_updateGouge_safe = false;
    }
    axios
      .get(
        `/v1/realtime/eilat/velocity/minutes?token=${token}&areas=null`
        //  {
        //   // withCredentials: true,
        // }
      )
      .then((res) => {
        let map = new Map();
        // console.log(res.data);
        for (let i = 0; i < res.data.length; i++) {
          let velocity = res.data[i].velocity;
          let timestamp = res.data[i].timestamp;
          if (!checkIfXSecPass(timestamp, 10)) {
            if (velocity) {
              map.set(res.data[i]["sensor"], velocity);
            } else {
              map.set(res.data[i]["sensor"], 0);
            }
          } else {
            map.set(res.data[i]["sensor"], 0);
          }
          // console.log(velocity);
        }
        setDeviceKeys((prev) => [...map.keys()].reverse());
        setdeviceVelocity((prev) => [...map.values()].reverse());
        setdevicesNames((prev) => [...map.keys()].reverse());
        setLoadingGouge(false);

        // TODO: need to check if this if needed
        // if (JSON.stringify(timelineData) !== JSON.stringify(resData)) {
        // if (totalCountVehicles !== totalVehicles) {
        //   setTotalCountVehicles((prev) => totalVehicles);
        // }

        request_updateTimelineData_safe = true;
      })
      .catch((err) => {
        console.log(
          "error with get hour statistic inside today vehicles-> ",
          err
        );
        request_updateGouge_safe = true;
      });
    request_updateGouge_safe = true;
  }

  function updateTimelineData() {
    if (request_updateTimelineData_safe === false) {
      return;
    } else {
      request_updateTimelineData_safe = false;
    }
    axios
      .get(
        `/v1/statistics/hour?token=${token}&day=${new Date().getUTCDate()}&month=${
          new Date().getUTCMonth() + 1
        }&areas=${null}`
      )
      .then((res) => {
        let resData = [];
        let resHotelData = [];
        let totalVehicles = 0;
        let mapPie = new Map();
        let devices = [
          ...new Set(
            res.data
              .map((value) => {
                return value
                  .map((val) => {
                    return val["deviceId"];
                  })
                  .flat();
              })
              .flat()
          ),
        ];
        for (let i = 0; i < devices.length; i++) {
          const element = devices[i];
          mapPie.set(element, []);
        }
        let dimXY = res.data.map((values) => {
          return values.map((val) => {
            let device = val["deviceId"];
            let arr = mapPie.get(device);
            let dimXY = val["dimXY"]
              .map((arg) => {
                return arg["Type"];
              })
              .flat();
            arr = arr.concat(dimXY);
            mapPie.set(val["deviceId"], arr);
            return dimXY.flat();
          });
        });
        dimXY = dimXY.flat();
        let types = [...new Set(dimXY.flat())];
        setTypes((prev) => types);
        setPie((prev) => mapPie);
        for (let i = 0; i < res.data.length; i++) {
          for (let j = 0; j < res.data[i].length; j++) {
            // Minus 1 to hide current hour (if now it's 10:40, show in the chart only until 9:59)
            if (
              new Date(res.data[i][j]["date"]).getHours() <=
              new Date().getHours()
            ) {
              let device = res.data[i][j]["deviceId"];

              if (device === "600a0c2a69e88a8c") {
                resData.push({
                  hour: getLocalHour(res.data[i][j]["date"]),
                  deviceId: res.data[i][j]["deviceId"],
                  inCount: 0,
                  outCount: res.data[i][j]["objectCount"],
                  vehiclesCount: res.data[i][j]["vehiclesCount"],
                  otherCount: res.data[i][j]["otherCount"],
                });
              } else if(device === "600a0c2a69e88a8e") {
                // console.log(res.data[i][j],"fyndata");
                resData.push({
                  hour: getLocalHour(res.data[i][j]["date"]),
                  deviceId: res.data[i][j]["deviceId"],
                  inCount: res.data[i][j]["objectCount"],
                  outCount: 0,
                  vehiclesCount: res.data[i][j]["vehiclesCount"],
                  otherCount: res.data[i][j]["otherCount"],
                });
              } else {
                resHotelData.push({
                  hour: getLocalHour(res.data[i][j]["date"]),
                  deviceId: res.data[i][j]["deviceId"],
                  // inCount: res.data[i][j]["objectCount"],
                  outCount: res.data[i][j]["outCount"],
                  inCount: res.data[i][j]["inCount"],
                });
              }

              totalVehicles += res.data[i][j]["totalCount"];
            }
          }
        }
        // TODO: need to check if this if needed
        // if (JSON.stringify(timelineData) !== JSON.stringify(resData)) {
        // resData = margeSameHours(resData);
        // console.log(resData,"resata");
        resHotelData = fillLine(resHotelData);
        // console.log(resData,"resata");
        // console.log(resHotelData,"hoyel");
        setLoadingChart(false);
        setTimelineData((prev) => resData);
        setHotelTimelineData((prev) => resHotelData);
        if (totalCountVehicles !== totalVehicles) {
          setTotalCountVehicles((prev) => totalVehicles);
        }
        request_updateTimelineData_safe = true;
      })
      .catch((err) => {
        console.log(
          "error with get hour statistic inside today vehicles-> ",
          err
        );
      });
    request_updateTimelineData_safe = true;
  }

  function updateTotalWeekAgo() {
    if (request_updateTotalWeekAgo_safe === false) {
      return;
    } else {
      request_updateTotalWeekAgo_safe = false;
    }
    let week_ago = new Date();
    let vehiclesCount = 0;
    week_ago.setDate(week_ago.getDate() - 7);
    axios
      .get(
        `/v1/statistics/week/hour?token=${token}&day=${week_ago.getUTCDate()}&month=${
          week_ago.getUTCMonth() + 1
        }`
        // { withCredentials: true }
      )
      .then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          for (let j = 0; j < res.data[i].length; j++) {
            let only_hour = parseInt(res.data[i][j]["hour"].split(":")[0]);
            if (only_hour <= parseInt(new Date().getHours())) {
              vehiclesCount += res.data[i][j]["totalCount"];
            }
          }
        }
        setTotalWeekAgo((prev) => vehiclesCount);
        request_updateTotalWeekAgo_safe = true;
      })
      .catch((err) => {
        console.log(
          "error with get hour statistic inside today vehicles-> ",
          err
        );
      });
    request_updateTotalWeekAgo_safe = false;
  }

  useEffect(() => {
    // setTimeout(() => {
    updateTimelineData();
    updateGougeData();
    getDeviceNames();
    // }, 1000);

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Get the up-to-date data for the in-out chart every 1 sec
  // useInterval(
  //   () => {
  //     // if (!loadingGouge) {
  //     updateGougeData();
  //     // }
  //   },
  //   3001,
  //   true
  // );

  // Get the data for the in-out count from week ago
  useEffect(() => {
    updateTotalWeekAgo();
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // Get the up-to-date data for the in-out chart every 1 sec
  useInterval(
    () => {
      updateGougeData();
      const [number, color] = calcPercent(totalWeekAgo, totalCountVehicles);
      setCompareText(number);
      setCompareColor(color);
    },
    !loadingChart ? 1000 : 3000,
    true
  );
  // Get the up-to-date data for the in-out chart every 1 sec
  useInterval(
    () => {
      // if (!loadingChart) {
      updateTimelineData();
      // }
    },
    !loadingChart ? 1000 : 10000,
    true
  );

  // Get the up-to-date data for the in-out count from week ago every 1 sec
  useInterval(
    () => {
      updateTotalWeekAgo();
    },
    !loadingChart ? 2000 : 30000,
    true
  );

  // if (loading) {
  //   return (
  //     <div className="bg-gray-300 flex-auto w-full h-full rounded-md overflow-hidden transition-all">
  //       <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
  //     </div>
  //   );
  // }
  if (loadingChart || loadingGouge) {
    return (
      <div className="flex justify-center">
        <div className="bg-gray-300  w-full px-4 h-95/100 rounded-md overflow-hidden transition-all">
          <div className="w-full h-full opacity-50 transform -translate-x-full bg-gradient-to-r from-transparent via-white to-transparent animate-slide"></div>
        </div>
      </div>
    );
  }
  return (
//     <div className="flex flex-col h-full w-full justify-around ">
//       {console.log(deviceVelocity)}
//       {console.log(timelineData)}
//       {deviceVelocity.length > 0 &&
//         Array.from(deviceVelocity).map(
//           (value, index) => (
//             <div
//             key={deviceKeys.at(index)}
//             className={`
//             text-center flex flex-col  rounded-xl mt-2 bg-white  `}
//             >
//               <div className=" text-center flex w-full h-full flex-col justify-items-center justify-center   ">
//                 <div
//                   className="flex flex-row items-center  justify-evenly"
//                   key={index}
//                 >
//                   <div
//                     className="w-2/3  rounded-lg "
//                     key={deviceKeys.at(index) + "1"}
//                   >
//                     <div className="flex w-full h-full p-2 flex-row rounded-md ">
//                       {/* <svg
//                         xmlns="http://www.w3.org/2000/svg"
//                         className="h-5 w-5 "
//                         viewBox="0 0 20 20"
//                         fill={
//                           devicesNames[index] === "600a0c2a69e88a8e"
//                             ? "#013987"
//                             : "#7206c4"
//                         }
//                       >
//                         <path
//                           fillRule="evenodd"
//                           d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
//                           clipRule="evenodd"
//                         />
//                       </svg>
//                       <p className="text-sm text-blue-800  px-1">
//                         {devicesNames[index] === "600a0c2a69e88a8e"
//                           ? "Entering Eilat"
//                           : "Leaving Eilat"}
//                       </p> */}
//                     </div>
//                     <div className="flex  flex-row px-10">
//                       <div className="h-32 w-full px-2">
//                         <ResponsiveContainer>
//                           <AreaChart
//                             key={deviceKeys.at(index) + index}
//                             data={timelineData}
//                             margin={{
//                               top: 30,
//                               right: 10,
//                               left: 10,
//                               bottom: 10,
//                             }}
//                             id={
//                               devicesNames[index] === "600a0c2a69e88a8e"
//                                 ? "1"
//                                 : "2"
//                             }
//                           >
//                             <defs>
//                               <linearGradient
//                                 id={
//                                   devicesNames[index] === "600a0c2a69e88a8e"
//                                     ? "600a0c2a69e88a8e"
//                                     : "600a0c2a69e88a8c"
//                                 }
//                                 x1="0"
//                                 y1="0"
//                                 x2="0"
//                                 y2="1"
//                               >
//                                 <stop
//                                   offset="50%"
//                                   stopColor={
//                                     devicesNames[index] === "600a0c2a69e88a8e"
//                                       ? "#0054c9"
//                                       : "#7206c4"
//                                   }
//                                   opacity={"0.8"}
//                                 />
//                                 <stop
//                                   offset="95%"
//                                   stopColor="#8884d8"
//                                   stopOpacity={0}
//                                 />
//                               </linearGradient>
//                             </defs>
//                             <Tooltip
//                               coordinate={{ x: 0, y: 0 }}
//                               offset={0}
//                               allowEscapeViewBox={{ x: false, y: true }}
//                               content={
//                                 devicesNames[index] === "600a0c2a69e88a8e" ? (
//                                   <CustomTooltip />
//                                 ) : (
//                                   <CustomTooltips />
//                                 )
//                               }
//                             />
//                             <XAxis
//                               axisLine={false}
//                               tick={{ fontSize: "0.5rem" }}
//                               interval="preserveStartEnd"
//                               height={15}
//                               dataKey="hour"
//                             />
//                             <YAxis
//                               axisLine={false}
//                               tickLine={true}
//                               tick={{ fontSize: "0.6rem" }}
//                               width={30}
//                               interval="preserveStartEnd"
//                               dataKey={
//                                 devicesNames[index] === "600a0c2a69e88a8e"
//                                   ? "inCount"
//                                   : "outCount"
//                               }
//                             />

//                             {
//                               <Area
//                                 type="natural"
//                                 dataKey={
//                                   devicesNames[index] === "600a0c2a69e88a8e"
//                                     ? "inCount"
//                                     : "outCount"
//                                 }
//                                 key={
//                                   devicesNames[index] === "600a0c2a69e88a8e"
//                                     ? "inCount"
//                                     : "outCount"
//                                 }
//                                 stroke={
//                                   devicesNames[index] === "600a0c2a69e88a8e"
//                                     ? "#013987"
//                                     : "#4d0187"
//                                 }
//                                 strokeWidth={1}
//                                 fillOpacity={0.2}
//                                 fill={
//                                   devicesNames[index] === "600a0c2a69e88a8e"
//                                     ? "url(#600a0c2a69e88a8e)"
//                                     : "url(#600a0c2a69e88a8c)"
//                                 }
//                               />
//                             }
//                           </AreaChart>
//                         </ResponsiveContainer>
//                       </div>
//                     </div>
//                   </div>
//                   {/* <EilatGouge speed={value} /> */}
//                   {/* {types.length > 0 && (
//                     <EilatPieChart
//                       device={deviceKeys.at(index)}
//                       pieData={pie}
//                       types={types}
//                       colors={colors}
//                     />
//                   )} */}
//                 </div>
//               </div>
//             </div>
//           ),
//           [deviceVelocity, deviceKeys]
//         )}
//         {true && <div className={`text-center flex flex-col  rounded-xl mt-2 bg-white`} ><div className="flex  flex-row px-10">
//                       <div className="h-32 w-full px-2">
//                         <ResponsiveContainer>
//                           <AreaChart
//                             key={deviceKeys.at(indexOne) + indexOne}
//                             data={timelineData}
//                             margin={{
//                               top: 30,
//                               right: 10,
//                               left: 10,
//                               bottom: 10,
//                             }}
//                             id={
//                               devicesNames[indexOne] === "600a0c2a69e88a8c"
//                                 ? "1"
//                                 : "2"
//                             }
//                           >
//                             <defs>
//                               <linearGradient
//                                 id={
//                                   devicesNames[indexOne] === "600a0c2a69e88a8c"
//                                     ? "600a0c2a69e88a8e"
//                                     : "600a0c2a69e88a8c"
//                                 }
//                                 x1="0"
//                                 y1="0"
//                                 x2="0"
//                                 y2="1"
//                               >
//                                 <stop
//                                   offset="50%"
//                                   stopColor={
//                                     devicesNames[indexOne] === "600a0c2a69e88a8c"
//                                       ? "#0054c9"
//                                       : "#7206c4"
//                                   }
//                                   opacity={"0.8"}
//                                 />
//                                 <stop
//                                   offset="95%"
//                                   stopColor="#8884d8"
//                                   stopOpacity={0}
//                                 />
//                               </linearGradient>
//                             </defs>
//                             <Tooltip
//                               coordinate={{ x: 0, y: 0 }}
//                               offset={0}
//                               allowEscapeViewBox={{ x: false, y: true }}
//                               content={
//                                 devicesNames[indexOne] === "600a0c2a69e88a8c" ? (
//                                   <CustomTooltip />
//                                 ) : (
//                                   <CustomTooltips />
//                                 )
//                               }
//                             />
//                             <XAxis
//                               axisLine={false}
//                               tick={{ fontSize: "0.5rem" }}
//                               interval="preserveStartEnd"
//                               height={15}
//                               dataKey="hour"
//                             />
//                             <YAxis
//                               axisLine={false}
//                               tickLine={true}
//                               tick={{ fontSize: "0.6rem" }}
//                               width={30}
//                               interval="preserveStartEnd"
//                               dataKey={
//                                 devicesNames[indexOne] === "600a0c2a69e88a8c"
//                                   ? "inCount"
//                                   : "outCount"
//                               }
//                             />

//                             {
//                               <Area
//                                 type="natural"
//                                 dataKey={
//                                   devicesNames[indexOne] === "600a0c2a69e88a8e"
//                                     ? "inCount"
//                                     : "outCount"
//                                 }
//                                 key={
//                                   devicesNames[indexOne] === "600a0c2a69e88a8e"
//                                     ? "inCount"
//                                     : "outCount"
//                                 }
//                                 stroke={
//                                   devicesNames[indexOne] === "600a0c2a69e88a8e"
//                                     ? "#013987"
//                                     : "#4d0187"
//                                 }
//                                 strokeWidth={1}
//                                 fillOpacity={0.2}
//                                 fill={
//                                   devicesNames[indexOne] === "600a0c2a69e88a8e"
//                                     ? "url(#600a0c2a69e88a8e)"
//                                     : "url(#600a0c2a69e88a8c)"
//                                 }
//                               />
//                             }

// {
//                               <Area
//                                 type="natural"
//                                 dataKey={
//                                   devicesNames[indexOne] === "600a0c2a69e88a8c"
//                                     ? "inCount"
//                                     : "outCount"
//                                 }
//                                 key={
//                                   devicesNames[indexOne] === "600a0c2a69e88a8c"
//                                     ? "inCount"
//                                     : "outCount"
//                                 }
//                                 stroke={
//                                   devicesNames[indexOne] === "600a0c2a69e88a8c"
//                                     ? "#013987"
//                                     : "#4d0187"
//                                 }
//                                 strokeWidth={1}
//                                 fillOpacity={0.2}
//                                 fill={
//                                   devicesNames[indexOne] === "600a0c2a69e88a8c"
//                                     ? "url(#600a0c2a69e88a8e)"
//                                     : "url(#600a0c2a69e88a8c)"
//                                 }
//                               />
//                             }
//                           </AreaChart>
//                         </ResponsiveContainer>
//                       </div>
//                     </div>
//                     </div>}
//       {deviceVelocity.length === 0 && (
//         <div
//           className={`
//          text-center rounded-2xl mx-10 `}
//         >
//           <div className="font-bold text-lg text-gray-600  ">
//             No Sensor at Service
//             {/* {console.log(deviceKeys.at(index))} */}
//           </div>
//           <div className="flex flex-col  self-center mx-10">
//             <EilatGouge key={0} speed={0} />
//           </div>
//         </div>
//       )}
//     </div>
<div style={{backgroundColor:"#fbfbfb",borderRadius:"9px"}} >
  {/* <GroupedStackedBarChart data={timelineData} /> */}
  <StackedChart data={timelineData} direction={"In"} />
  <div style={{height:"1vh", backgroundColor:"#bbc4dc"}} > </div>
  <StackedChart data={timelineData} direction={"Out"} />
  <div style={{height:"1vh", backgroundColor:"#bbc4dc"}} > </div>
  <LineChart data={hotelTimelineData} />
</div>
  );
};

export default EilatGougeAndChartToday;
